// src/services/consumerService.ts
import api from './api';
import { Consumer, CreateConsumerRequest } from '../types';

export const consumerService = {
  getAll: () => api.get<Consumer[]>('/consumers'),
  getById: (id: number) => api.get<Consumer>(`/consumers/${id}`),
  create: (data: CreateConsumerRequest) => api.post<Consumer>('/consumers', data),
  update: (id: number, data: CreateConsumerRequest) => api.put<Consumer>(`/consumers/${id}`, data),
  delete: (id: number) => api.delete(`/consumers/${id}`),
};
